import {useContext, useEffect} from 'react'
import {createSearchParams, useSearchParams} from 'react-router-dom'
import {Row, Segmented} from 'antd'
import {NavContext} from '../../context/global_context'
import {getSessionStorageData} from '../../utils/SessionStorage'
import {USER_MANAGEMENT} from '../../constants/permission'
import {useIntl} from 'react-intl'

import UserList from './users'
import UserStore from './users/context/context'
import PlantList from './plants'
import PlantStore from './plants/context/context'
import TestZoneStore from './test_zones/context/context'
import TestZones from './test_zones'
import ShiftStore from './shifts/context/context'
import Shifts from './shifts'
import AppsStore from './apps/context/context'
import OAuthApps from './apps'
import CognitoClientsStore from './cognito_clients/context/context'
import CognitoClients from './cognito_clients'

const Administration = () => {
  const intl = useIntl()
  const [value, dispatch] = useContext(NavContext)

  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`

  useEffect(() => {
    dispatch({
      type: 'header',
      data: {
        header: intl.formatMessage({ id: 'layout.administration' }),
        sub_header: intl.formatMessage({ id: 'administration.subHeader' }),
        id: '',
        show_back_btn: true,
        dtc_details: {},
        vehicle: '',
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
  }, [])

  const hasUserManagement = value?.permissions?.includes(USER_MANAGEMENT)

  const tabs = [
    ...(hasUserManagement
      ? [
          {
            value: 'users',
            label: intl.formatMessage({ id: 'administration.users' }),
          },
        ]
      : []),
    {
      value: 'plants',
      label: intl.formatMessage({ id: 'administration.plants' }),
    },
    {
      value: 'test_zones',
      label: intl.formatMessage({ id: 'administration.testZones' }),
    },
    {
      value: 'shifts',
      label: intl.formatMessage({ id: 'administration.shifts' }),
    },
    {
      value: 'apps',
      label: intl.formatMessage({ id: 'administration.apps' }),
    },
    ...(value?.is_admin
      ? [
          {
            value: 'cognito_clients',
            label: intl.formatMessage({ id: 'administration.cognitoClients' }),
          },
        ]
      : []),
  ]

  const [searchParams, setSearchParams] = useSearchParams()
  const defaultTab = hasUserManagement ? 'users' : 'plants'
  const rawTab = searchParams.get('tab')
  const activeTab = tabs.some((tab) => tab.value === rawTab)
    ? rawTab
    : defaultTab

  const handleTabChange = (value) => {
    const nextParams = new URLSearchParams(searchParams)
    nextParams.set('tab', value)
    setSearchParams(nextParams, { replace: true })
  }

  useEffect(() => {
    if (rawTab && activeTab !== rawTab) {
      const nextParams = new URLSearchParams(searchParams)
      nextParams.set('tab', activeTab)
      setSearchParams(nextParams, { replace: true })
    }
  }, [rawTab])

  return (
    <div className="page administration">
      <Row className="title">
        <Segmented
          options={tabs.map((tab) => ({ label: tab.label, value: tab.value }))}
          value={activeTab}
          onChange={handleTabChange}
        />
      </Row>

      {value?.header && (
        <div>
          {activeTab === 'users' && hasUserManagement && (
            <UserStore>
              <UserList />
            </UserStore>
          )}
          {activeTab === 'plants' && (
            <PlantStore>
              <PlantList />
            </PlantStore>
          )}
          {activeTab === 'test_zones' && (
            <TestZoneStore>
              <TestZones />
            </TestZoneStore>
          )}
          {activeTab === 'shifts' && (
            <ShiftStore>
              <Shifts />
            </ShiftStore>
          )}
          {activeTab === 'apps' && (
            <AppsStore>
              <OAuthApps />
            </AppsStore>
          )}
          {activeTab === 'cognito_clients' && value?.is_admin && (
            <CognitoClientsStore>
              <CognitoClients />
            </CognitoClientsStore>
          )}
        </div>
      )}
    </div>
  )
}

export default Administration
